import { Component, OnDestroy, OnInit } from '@angular/core';
import { AuthFacade } from '@tvt-logistics-india/data-access';
import { from, Subscription } from 'rxjs';
import { Auth } from 'aws-amplify';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';

@Component({
  selector: 'tvt-logistics-india-sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.scss'],
})
export class SignInComponent implements OnInit, OnDestroy {
  forgotPassword: boolean = false;
  forgotPasswordSubscription: Subscription;
  constructor(
    public authFacade: AuthFacade,
    private _snackBar: MatSnackBar,
    public router: Router
  ) {}

  ngOnInit(): void {}

  onSubmit(email: any, password: any) {
    if (email.value && password.value) {
      this.authFacade.signIn(email.value, password.value);
    }
  }

  onUsername(data: any) {
    if (data.target.value) {
      this.forgotPassword = true;
    } else {
      this.forgotPassword = false;
    }
  }

  onForgotPassword(username) {
    if (username.value) {
      this.forgotPassword = false;
      this.forgotPasswordSubscription = from(
        Auth.forgotPassword(username?.value)
      ).subscribe(
        (data) => {
          this.router.navigate(['/forgot-password'], {
            queryParams: { username: username.value },
          });
          this._snackBar.open('Code Sent Successfully', null, {
            duration: 5000,
            horizontalPosition: 'right',
            verticalPosition: 'top',
            panelClass: 'custom-snackbar-success',
          });
        },
        (error) => {
          this._snackBar.open(error.message, null, {
            duration: 5000,
            horizontalPosition: 'right',
            verticalPosition: 'top',
            panelClass: 'custom-snackbar-error',
          });
        }
      );
    }
  }

  ngOnDestroy() {
    this.forgotPasswordSubscription?.unsubscribe();
  }
}
